<template>
  <b-row class="base-row-padded">
    <b-col>
      <b-row>
        <b-col cols="4">
          <b-button variant="light" :to="{ name: 'devices' }"> &lt; Back to Devices</b-button>
        </b-col>
        <b-col cols="8" class="d-flex justify-content-end">
          <b-button :disabled="formLoading" class="ml-2" variant="success" @click="handleSubmit">Save</b-button>
          <b-button :disabled="formLoading" class="ml-2" v-if="id !== 'new'" variant="danger"
            @click="deleteDeviceProxy">Delete</b-button>
        </b-col>
        <b-col cols="12" class="my-2">
          <h2>{{ !this.checkout ? 'Device' : 'New Checkout' }}</h2>
        </b-col>
      </b-row>
      <b-form @submit.prevent="handleSubmit" v-if="device">

        <b-form-group>
          <b-card header="Device Information">
            <b-form-group label="Name:">
              <b-form-input v-model="device.name" required placeholder="Name" />
              <b-form-invalid-feedback v-if="formErrors && formErrors.name && formErrors.name.length > 0"
                :state="false">
                <p v-for="(e, $index) in formErrors.name" :key="$index">{{ e }}</p>
              </b-form-invalid-feedback>
            </b-form-group>

            <template v-if="this.checkout && this.id === 'new'">
              <b-form-group label="Activation Code L:">
                <b-form-input v-model="checkoutData.activation_code_l" required placeholder="Activation Code L" />
                <b-form-invalid-feedback
                  v-if="formErrors && formErrors.activation_code_l && formErrors.activation_code_l.length > 0"
                  :state="false">
                  <p v-for="(e, $index) in formErrors.activation_code_l" :key="$index">{{ e }}</p>
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Activation Code R:">
                <b-form-input v-model="checkoutData.activation_code_r" required placeholder="Activation Code R" />
                <b-form-invalid-feedback
                  v-if="formErrors && formErrors.activation_code_r && formErrors.activation_code_r.length > 0"
                  :state="false">
                  <p v-for="(e, $index) in formErrors.activation_code_r" :key="$index">{{ e }}</p>
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Activation Code B:">
                <b-form-input v-model="checkoutData.activation_code_b" required placeholder="Activation Code B" />
                <b-form-invalid-feedback
                  v-if="formErrors && formErrors.activation_code_b && formErrors.activation_code_b.length > 0"
                  :state="false">
                  <p v-for="(e, $index) in formErrors.activation_code_b" :key="$index">{{ e }}</p>
                </b-form-invalid-feedback>
              </b-form-group>
            </template>

            <!-- <list-autocomplete
              v-if="cities"
              label="City"
              fieldName="city"
              :formErrors="formErrors"
              v-model="device.city"
              :options="cities"
              >
            </list-autocomplete> -->

            <!--<b-form-group label="City:">
              <b-form-select v-model="device.city">
                <option :value="null"></option>
                <option v-for="(item, $index) in cities" :value="item.value" :required="true" :key="$index">{{item.text}}</option>
              </b-form-select>
              <b-form-invalid-feedback
                v-if="formErrors && formErrors.city && formErrors.city.length > 0" :state="false">
                <p v-for="(e, $index) in formErrors.city" :key="$index">{{e}}</p>
              </b-form-invalid-feedback>
            </b-form-group>-->

            <b-form-group label="Address:">
              <b-form-input v-model="device.address" placeholder="Address" />
              <b-form-invalid-feedback v-if="formErrors && formErrors.address && formErrors.address.length > 0"
                :state="false">
                <p v-for="(e, $index) in formErrors.address" :key="$index">{{ e }}</p>
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Activation Code:" v-if="!this.checkout">
              <b-form-input v-model="device.activation_code" required placeholder="Activation Code" />
              <b-form-invalid-feedback
                v-if="formErrors && formErrors.activation_code && formErrors.activation_code.length > 0" :state="false">
                <p v-for="(e, $index) in formErrors.activation_code" :key="$index">{{ e }}</p>
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="IP Address:">
              <b-form-input v-model="device.ip" placeholder="IP Address" />
              <b-form-invalid-feedback v-if="formErrors && formErrors.ip && formErrors.ip.length > 0" :state="false">
                <p v-for="(e, $index) in formErrors.ip" :key="$index">{{ e }}</p>
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Password:">
              <b-form-input v-model="device.password" :type="'password'" placeholder="Password" />
              <b-form-invalid-feedback v-if="formErrors && formErrors.password && formErrors.password.length > 0"
                :state="false">
                <p v-for="(e, $index) in formErrors.password" :key="$index">{{ e }}</p>
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="PMI Code:">
              <b-form-input v-model="device.pmi_code" :required="true" placeholder="PMI Code" />
              <b-form-invalid-feedback v-if="formErrors && formErrors.pmi_code && formErrors.pmi_code.length > 0"
                :state="false">
                <p v-for="(e, $index) in formErrors.pmi_code" :key="$index">{{ e }}</p>
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="POS Code:">
              <b-form-input v-model="device.pos_code" required placeholder="POS Code" />
              <b-form-invalid-feedback v-if="formErrors && formErrors.pos_code && formErrors.pos_code.length > 0"
                :state="false">
                <p v-for="(e, $index) in formErrors.pos_code" :key="$index">{{ e }}</p>
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Position:">
              <b-form-select v-model="device.position">
                <option :value="null">None</option>
                <option v-for="(value, $index) in positions" :value="value" :key="$index">{{ value }}</option>
              </b-form-select>
              <b-form-invalid-feedback v-if="formErrors && formErrors.position && formErrors.position.length > 0"
                :state="false">
                <p v-for="(e, $index) in formErrors.position" :key="$index">{{ e }}</p>
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Channel split:">
              <b-form-select v-model="device.channel">
                <option :value="null">None</option>
                <option v-for="(item, $index) in channels" :value="item.value" :key="$index">{{ item.text }}</option>
              </b-form-select>
              <b-form-invalid-feedback v-if="formErrors && formErrors.channel && formErrors.channel.length > 0"
                :state="false">
                <p v-for="(e, $index) in formErrors.channel" :key="$index">{{ e }}</p>
              </b-form-invalid-feedback>
            </b-form-group>

            <list-autocomplete v-if="cityOptions" label="City:" fieldName="city" :formErrors="formErrors"
              v-model="device.city" :options="cityOptions" required>
            </list-autocomplete>

            <b-form-group label="Tier:">
              <b-form-input :value="cities[device.city] ? cities[device.city]['tier_name'] : ''" required
                placeholder="Tier" readonly />
            </b-form-group>

            <b-form-group label="Parent name:">
              <b-form-input v-model="device.parent_name" required placeholder="Parent name" />
              <b-form-invalid-feedback v-if="formErrors && formErrors.parent_name && formErrors.parent_name.length > 0"
                :state="false">
                <p v-for="(e, $index) in formErrors.parent_name" :key="$index">{{ e }}</p>
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="RRP POS Type:">
              <b-form-select v-model="device.rrp_pos_type" required>
                <option :value="null">None</option>
                <option v-for="(item, $index) in tags" :value="item.value" :key="$index">{{ item.text }}</option>
              </b-form-select>
              <b-form-invalid-feedback
                v-if="formErrors && formErrors.rrp_pos_type && formErrors.rrp_pos_type.length > 0" :state="false">
                <p v-for="(e, $index) in formErrors.rrp_pos_type" :key="$index">{{ e }}</p>
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group>
              <b-checkbox v-model="device.print" :value="1" :unchecked-value="0">
                Print
              </b-checkbox>
              <b-form-invalid-feedback v-if="formErrors && formErrors.print && formErrors.print.length > 0"
                :state="false">
                <p v-for="(e, $index) in formErrors.print" :key="$index">{{ e }}</p>
              </b-form-invalid-feedback>
            </b-form-group>
          </b-card>
        </b-form-group>

        <ObjectSettings v-if="id !== 'new'" :settingsObj="device.settings" />

        <b-form-group v-if="id === 'new'">
          <template v-if="this.checkout">
            <b-card header="Device Groups" no-body>
              <b-tabs card>
                <b-tab title="Group L">
                  <GroupsViewer :picker-mode="true" :picked-item-id="this.checkoutData.group_id_l"
                    @item-clicked="selectGroupCheckout('group_id_l', $event)">
                  </GroupsViewer>
                </b-tab>
                <b-tab title="Group R">
                  <GroupsViewer :picker-mode="true" :picked-item-id="this.checkoutData.group_id_r"
                    @item-clicked="selectGroupCheckout('group_id_r', $event)">
                  </GroupsViewer>
                </b-tab>
                <b-tab title="Group B">
                  <GroupsViewer :picker-mode="true" :picked-item-id="this.checkoutData.group_id_b"
                    @item-clicked="selectGroupCheckout('group_id_b', $event)">
                  </GroupsViewer>
                </b-tab>
              </b-tabs>
            </b-card>
          </template>
          <template v-else>
            <b-card header="Device Group">
              <GroupsViewer :picker-mode="true" :picked-item-id="device.group_id" @item-clicked="selectGroup">
              </GroupsViewer>
            </b-card>
          </template>
        </b-form-group>

        <b-form-group v-if="device.group">
          <b-card header-tag="header">
            <div slot="header" class="d-flex align-items-center justify-content-between">
              Device Group Information
              <router-link :to="{ name: 'showGroup', params: { id: device.group.id } }">Edit</router-link>
            </div>
            <b-form-group label="Group:">
              <b-form-input v-model="device.group.name" disabled />
            </b-form-group>
            <b-form-group label="Playlist:" v-if="device.group.settings.playlist">
              <b-form-input v-model="device.group.settings.playlist.name" disabled />
            </b-form-group>

            <ObjectSettings :settings-obj="device.group.settings" :readonly="true" />
          </b-card>
        </b-form-group>

      </b-form>

    </b-col>
  </b-row>
</template>

<script>
import formsMixin from '@/mixins/forms';
import settingsMixin from '@/mixins/settings';
import devicesMixin from './devicesMixin';
import ObjectSettings from '@/views/admin/shared/ObjectSettings.vue';
import GroupsViewer from '@/components/GroupsViewer.vue';
import ListAutocomplete from '@/components/ListAutocomplete.vue';
import { DeviceAttrService } from '../../../services/deviceAttrService';

export default {
  mixins: [formsMixin, settingsMixin, devicesMixin],
  components: {
    ObjectSettings, GroupsViewer, ListAutocomplete,
  },
  data() {
    return {
      device: null,
      checkoutData: null,
      channels: [],
      tiers: [],
      positions: ['Single', 'Left', 'Right', 'Middle/Back'],
      tags: [],
      cityOptions: [],
      cities: {},
    };
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    checkout: {
      type: Boolean,
      required: false,
      default: false,
    },
    deviceObj: {
      type: [Object],
      required: false,
    },
  },
  async created() {
    const {
      tags, tiers, channels, cities,
    } = await DeviceAttrService.getAllAttrs(false);
    this.cityOptions = Object.keys(cities);
    this.tags = tags;
    this.cities = cities;
    this.tiers = tiers;
    this.channels = channels;
    if (this.id !== 'new') {
      this.getDeviceProxy();
    } else {
      this.device = {
        name: '',
        address: '',
        activation_code: '',
        ip: '',
        password: '',
        settings: this.generateEmptySettings(),
        city: '',
        pmi_code: '',
        pos_code: '',
        parent_name: '',
        position: null,
        group_id: -1,
        channel: null,
        tier: null,
        rrp_pos_type: null,
      };
      this.checkoutData = {
        activation_code_r: '',
        activation_code_l: '',
        activation_code_b: '',
        group_id_r: undefined,
        group_id_l: undefined,
        group_id_b: undefined,
      };
    }
  },
  methods: {
    getDeviceProxy() {
      if (!this.deviceObj) {
        this.getDevice({ id: this.id })
          .then((data) => {
            this.device = data;
            this.parseDevice(data);
          })
          .catch(() => { });
      } else {
        this.device = this.deviceObj;
        this.parseDevice(this.deviceObj);
      }
    },
    handleSubmit() {
      const deviceObject = { ...this.device };
      delete deviceObject.group;
      deviceObject.settings = { ...this.device.settings };
      delete deviceObject.settings.business_hours;
      deviceObject.settings.business_hours = this.flattenBusinessHours(this.device.settings);

      if (this.id === 'new') {
        if (deviceObject.group_id === -1) deviceObject.group_id = null;
        if (this.checkout) {
          this.createCheckout({ ...deviceObject, ...this.checkoutData });
        } else {
          this.createDevice(deviceObject)
            .then(() => { })
            .catch(() => { });
        }
      } else {
        this.updateDevice(deviceObject).then((updatedDevice) => {
          this.device = updatedDevice;
          this.parseDevice(updatedDevice);
        }).catch(() => { });
      }
    },
    deleteDeviceProxy() {
      this.deleteDevice(this.device).then(() => {
        this.$router.push({ name: 'devices' });
      })
        .catch(() => { });
    },
    async parseDevice(newDevice) {
      this.device = { ...newDevice };
      this.device.settings.business_hours = this.extendBusinessHours(this.device.settings);
      if (this.device.group && this.device.group.settings) {
        this.device.group.settings.business_hours = this.extendBusinessHours(this.device.group.settings);
      }
      // this.device.tag = newDevice.tag ? newDevice.tag.name : '';
      // const res = await DeviceAttrService.getAllAttrs(true);
      // this.tags = res.tags;
    },
    selectGroup(groupObject) {
      this.device.group_id = groupObject.id;
    },
    selectGroupCheckout(name, group) {
      this.checkoutData[name] = group.id;
    },
  },
};
</script>
